﻿<template>
    <section class="mb-card" v-if="($store.getters.get_Booking?.notes?.length ?? 0) > 0">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                Booking notes
            </h3>
            <div class="bd-notes">
                <div class="bd-note" v-for="(booking_note, index) in $store.getters.get_Booking.notes" :key="index">
                    <div class="bd-note-type">{{ booking_note.type }}</div>
                    <p>{{ booking_note.note }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./booking_notes.ts"></script>